import { createContext, useContext } from 'react';
export const CheckboxGroupContext = createContext({});
export const useCheckboxGroupContext = () => useContext(CheckboxGroupContext);
//# sourceMappingURL=checkbox-group-context.component.js.map